import { injectable } from "inversify";
import IRepository from "./IRepository";
import RepositoryBase from "./RepositoryBase";

@injectable()
export default class Repository<T> extends RepositoryBase<T>
  implements IRepository<T> {
}